import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';

const FooterLayout = () => {
  const theme = useTheme();

  const getLinkLabel = (path) => {
    const label = path
      .split('/')
      .pop()
      .replace(/-/g, ' ')
      .replace(/\b\w/g, (l) => l.toUpperCase());
    return label === 'Faq' ? 'FAQ' : label;
  };

  return (
    <Box
      component='footer'
      sx={{
        scrollSnapAlign: 'start',
        pt: { xs: 4, sm: 5 },
        pb: { xs: 5, sm: 6 },
        borderTop: '1px solid #ddd',
        backgroundColor: 'background.paper',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          px: 0,
          mx: 'auto',
          maxWidth: 1220,
        }}
      >
        <Box
          display='flex'
          gap={{ xs: 3, sm: 4 }}
          sx={{
            width: { xs: 'max-content !important', sm: '100% !important' },
            mb: { xs: 3, sm: 4 },
            justifyContent: { xs: 'space-around', lg: 'space-between' },
            flexDirection: { xs: 'column', sm: 'row' },
          }}
        >
          <Box>
            <Typography
              variant='subtitle1'
              fontWeight='bold'
              gutterBottom
              sx={{
                fontSize: { xs: '1rem', sm: '1.1rem' },
                mb: 2,
              }}
            >
              Company
            </Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1.5,
                '& a': {
                  color: theme.palette.text.secondary,
                  textDecoration: 'none',
                  fontSize: { xs: '0.9rem', sm: '0.95rem' },
                  transition: 'color 0.2s ease',
                  '&:hover': {
                    color: theme.palette.primary.main,
                  },
                },
              }}
            >
              {['/content/about', '/content/contact', '/content/whats-new', '/content/faq'].map((path) => (
                <Link key={path} to={path}>
                  {getLinkLabel(path)}
                </Link>
              ))}
            </Box>
          </Box>
          <Box>
            <Typography
              variant='subtitle1'
              fontWeight='bold'
              gutterBottom
              sx={{
                fontSize: { xs: '1rem', sm: '1.1rem' },
                mb: 2,
              }}
            >
              Legal
            </Typography>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1.5,
                '& a': {
                  color: theme.palette.text.secondary,
                  textDecoration: 'none',
                  fontSize: { xs: '0.9rem', sm: '0.95rem' },
                  transition: 'color 0.2s ease',
                  '&:hover': {
                    color: theme.palette.primary.main,
                  },
                },
              }}
            >
              {[
                { path: '/content/privacy-policy', text: 'Privacy Policy' },
                { path: '/content/terms-of-service', text: 'Terms of Service' },
                { path: '/content/user-data-deletion', text: 'User Data Deletion' },
                { path: '/content/client-terms', text: 'Terms & Conditions (Clients)' },
                { path: '/content/terms', text: 'Terms & Conditions (Lead Agents)' },
              ].map(({ path, text }) => (
                <Link key={path} to={path}>
                  {text}
                </Link>
              ))}
            </Box>
          </Box>
        </Box>
        <Box
          textAlign='center'
          sx={{
            mt: { xs: 3, sm: 4 },
            color: 'text.secondary',
            fontSize: { xs: '0.8rem', sm: '0.9rem' },
          }}
        >
          <Typography variant='caption'>&copy; {new Date().getFullYear()} TechXpander. All rights reserved.</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default FooterLayout;
